import PropTypes from 'prop-types'

const ReportsHeader = ({ title }) => {
    return (
        <header className='header'>
            <h1>{title}</h1>
        </header>
    )
}

ReportsHeader.defaultProps = {
    title: 'Reports',
}

ReportsHeader.propTypes = {
    title: PropTypes.string.isRequired,
}

export default ReportsHeader
